import React from 'react';
import MatGapCoreTransactionList from './MatGapCoreTransactionList';

export default function MatGapIncomingList() {
  return (
    <MatGapCoreTransactionList
      title="GAP Material - Incoming Transactions"
      opTypes={["incoming"]}
    />
  );
}
